export enum NEWS_SECTION {
  maxCardTitleLength = 48,
  listImageHeight = 84,
  listImageWidth = 126,
  newsCardHeight = 172,
}

export enum NEWS_DIALOG_SIZES {
  height = "640px",
  width = "684px",
  dialogImageHeight = 315,
  dialogImageWidth = 636,
  dialogContentLoaderHeight = 132,
  dialogContentLoaderWidth = 198,
  dialogTextContentLoaderHeightToMd = "40vh",
  releaseNewsDialogMinHeight = "393px",
}
